import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { useEmpresaStore } from '@/store/empresaStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const empresaSeleccionada = useEmpresaStore((state) => state.empresaSeleccionada);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!empresaSeleccionada && location.pathname !== '/empresas') {
    return <Navigate to="/empresas" replace />;
  }

  return <>{children}</>;
}
